import HorsesSearchPage from "@/components/horse/HorsesSearchPage";

export default [
  {
    path: "/horses",
    component: {
      render(h) {
        return h("router-view");
      }
    },
    meta: { breadcrumbI18n: "navigation:breadcrumbs.horses.title" },
    children: [
      {
        path: "",
        name: "HorsesSearchPage",
        component: HorsesSearchPage,
        meta: {
          keepAlive: true,
          anchor: "#jumpMobile"
        }
      },
      {
        path: "duplicate_management",
        component: () => import("@/components/duplicates/DuplicateMerge.vue"),
        name: "HorseDuplicateMerge",
        props: function (route) {
          return {
            mode: "horses",
            horseId: route.query.horseId,
            horseIdTwo: route.query.horseIdTwo
          };
        },
        meta: {
          anchor: "#jumpBreadcrumb"
        }
      },
      {
        path: "find_reg_horses",
        name: "HorseApplicationRegistration",
        component: () =>
          import("@/components/horse/HorseApplicationRegistration.vue"),
        meta: {
          breadcrumb: "Find horse",
          checkAllowance: true,
          anchor: "#jumpBreadcrumb"
        }
      },
      {
        path: "register_horse",
        name: "HorseApplicationRegistrationForm",
        props: {
          applicationId: null
        },
        component: () =>
          import("@/components/horse/forms/HorseApplicationRegistration.vue"),
        meta: {
          breadcrumb: "Register horse",
          anchor: "#jumpBreadcrumb",
          checkAllowance: true,
          allowanceRouteName: "HorseApplicationRegistration"
        }
      },
      {
        path: "horse_application/:applicationId",
        name: "HorseApplicationRegistrationFormUpdate",
        props: true,
        component: () =>
          import("@/components/horse/forms/HorseApplicationRegistration.vue"),
        meta: {
          breadcrumb: "Update horse",
          checkAllowance: true,
          allowanceRouteName: "HorseApplicationRegistration",
          anchor: "#jumpBreadcrumb"
        }
      },
      {
        path: "register_horse/:horseId",
        name: "HorseApplicationRegistrationFormSelectedHorse",
        component: () =>
          import("@/components/horse/forms/HorseApplicationRegistration.vue"),
        props: true,
        meta: {
          breadcrumb: "Register horse",
          checkAllowance: true,
          allowanceRouteName: "HorseApplicationRegistration",
          anchor: "#jumpBreadcrumb"
        }
      },
      {
        path: "new",
        name: "HorseCreationPage",
        component: () => import("@/components/horse/HorseForm.vue"),
        meta: {
          breadcrumb: "New",
          requireAuthorize: true,
          anchor: "#jumpBreadcrumb"
        }
      },
      {
        path: "duplicates",
        name: "DuplicateHorses",
        component: () => import("@/components/horse/DuplicateHorses.vue"),
        meta: {
          breadcrumb: "Duplicates",
          requireAuthorize: true,
          anchor: "#jumpBreadcrumb"
        }
      },
      {
        path: ":horseId",
        name: "HorseRoot",
        props: true,
        component: {
          render(h) {
            return h("router-view");
          }
        },
        meta: { breadcrumb: { breadcrumbName: "horseName" } },
        redirect: { name: "HorseProfilePage" },
        children: [
          {
            path: "",
            name: "HorseProfilePage",
            meta: { breadcrumb: "Profile", anchor: "#jumpBreadcrumb" },
            component: () => import("@/components/horse/HorseProfilePage.vue"),
            props: true
          },
          {
            path: "edit",
            name: "HorseEdit",
            component: () => import("@/components/horse/HorseForm.vue"),
            props: true,
            meta: {
              breadcrumb: "Edit",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },

          {
            path: "sport_licence_application",
            name: "HorseApplicationSportLicence",
            component: () =>
              import(
                "@/components/horse/forms/HorseApplicationSportLicence.vue"
              ),
            props: true,
            meta: {
              breadcrumb: "Sport licence",
              checkAllowance: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "sport_licence_application/:applicationId",
            name: "HorseApplicationSportLicenceUpdate",
            component: () =>
              import(
                "@/components/horse/forms/HorseApplicationSportLicence.vue"
              ),
            props: true,
            meta: {
              breadcrumb: "Sport licence",
              checkAllowance: true,
              anchor: "#jumpBreadcrumb"
            }
          },

          {
            path: "pony_measurement",
            name: "HorseApplicationPonyMeasurement",
            component: () =>
              import(
                "@/components/horse/forms/HorseApplicationPonyMeasurement.vue"
              ),
            props: true,
            meta: {
              breadcrumb: "Pony measurement",
              checkAllowance: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "pony_measurement/:applicationId",
            name: "HorseApplicationPonyMeasurementUpdate",
            component: () =>
              import(
                "@/components/horse/forms/HorseApplicationPonyMeasurement.vue"
              ),
            props: true,
            meta: {
              breadcrumb: "Pony measurement",
              checkAllowance: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "ownership_change",
            name: "HorseApplicationOwnershipChange",
            component: () =>
              import(
                "@/components/horse/forms/HorseApplicationOwnershipChange.vue"
              ),
            props: true,
            meta: {
              breadcrumb: "Ownership change",
              checkAllowance: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "ownership_change/:applicationId",
            name: "HorseApplicationOwnershipChangeUpdate",
            component: () =>
              import(
                "@/components/horse/forms/HorseApplicationOwnershipChange.vue"
              ),
            props: true,
            meta: {
              breadcrumb: "Ownership change",
              checkAllowance: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "fei_passport",
            name: "HorseApplicationFEIPassport",
            component: () =>
              import(
                "@/components/horse/forms/HorseApplicationFEIPassport.vue"
              ),
            props: true,
            meta: {
              breadcrumb: "FEI passport form",
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "fei_passport/:applicationId",
            name: "HorseApplicationFEIPassportFormUpdate",
            component: () =>
              import(
                "@/components/horse/forms/HorseApplicationFEIPassport.vue"
              ),
            props: true,
            meta: {
              breadcrumb: "FEI passport form",
              anchor: "#jumpBreadcrumb"
            }
          },

          {
            path: "medical_treatment/new",
            name: "HorseMedicalTreatmentFormNew",
            props: true,
            component: () =>
              import(
                "@/components/horse/medicalTreatments/HorseMedicalTreatmentForm.vue"
              ),
            meta: {
              breadcrumbI18n:
                "navigation:breadcrumbs.horseMedicalRecordAddEdit.title",
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "medical_treatment/:medicalTreatmentId",
            name: "HorseMedicalTreatmentFormEdit",
            props: true,
            component: () =>
              import(
                "@/components/horse/medicalTreatments/HorseMedicalTreatmentForm.vue"
              ),
            meta: {
              breadcrumbI18n:
                "navigation:breadcrumbs.horseMedicalRecordAddEdit.title",
              anchor: "#jumpBreadcrumb"
            }
          }
        ]
      }
    ]
  }
];
